export default Object.freeze({
	PRINCIPAL: 1,
	WITNESS: 2,
});